"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMenuItem = getMenuItem;
exports.getComponentFromProp = void 0;

var getComponentFromProp = function getComponentFromProp(instance, prop) {
  var slots = instance.slots && instance.slots();
  return slots[prop] || instance.props[prop];
};

exports.getComponentFromProp = getComponentFromProp;

function getMenuItem(item) {
  var _item$meta;

  return {
    path: item.path || '/',
    title: ((_item$meta = item.meta) === null || _item$meta === void 0 ? void 0 : _item$meta.title) || ''
  };
}